export enum ETipoEstrutura
{
    Pagina = 1,
    LandingPage = 2,
    Blog = 3,
    Produto = 4,
    Marca = 5,
    Categoria = 6,
}
